module.exports = __webpack_public_path__ + "media/images/bottom_seats-1e10758773de15650f323ed2034e441b.svg";